import mitt from 'mitt'
import { onReadyStateChange } from './fns/onReadyStateChange'
import { redirect } from './fns/redirect'
import { logEvent } from './fns/logEvent'
import { logClick } from './fns/logClick'


export const events = {
  initialize () {
    console.log('DEBUG (events) Initializing event monitoring.')

    const eventMonitor = mitt()

    eventMonitor.on('schedule:readyStateChange', onReadyStateChange)

    // Process redirects when required.
    eventMonitor.on('redirect', redirect)

    // Log all events to console.
    eventMonitor.on('*', logEvent)

    if ('addEventListener' in window) {
      window.addEventListener('click', logClick.bind(null, eventMonitor), false)
    }

    return { events: eventMonitor }
  }
}